import { IDOMManager } from './interfaces';

export class DOMManager implements IDOMManager {
  createScript = (id: string): HTMLScriptElement => {
    const doc: Document = document;
    const script: HTMLScriptElement = doc.createElement('script');
    script.id = id;

    return script;
  };

  createNoScript = (id: string): HTMLElement => {
    const doc: Document = document;
    const noscript = doc.createElement('noscript');
    noscript.id = id;

    return noscript;
  };

  appendToHead = (element: HTMLElement): void => {
    const doc: Document = document;
    if (doc.getElementById(element.id)) return;

    doc.head.appendChild(element);
  };

  appendToBody = (element: HTMLElement): void => {
    const doc: Document = document;
    if (doc.getElementById(element.id)) return;

    doc.body.appendChild(element);
  };

  removeFromHeadById = (id: string): void => {
    const doc: Document = document;
    const element = doc.getElementById(id);
    if (!element) return;

    doc.head.removeChild(element);
  };

  removeFromBodyById = (id: string): void => {
    const doc: Document = document;
    const element = doc.getElementById(id);
    if (!element) return;

    doc.body.removeChild(element);
  };

  appendToDatalayer = (event: object): void => {
    const win: Window = window;
    win.dataLayer = win.dataLayer || [];
    win.dataLayer.push(event);
  };
}
